/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { Image } from '@doveit/lego';
import * as styles from './CityCard.style';
import { URLObject } from '../../utils/links';

export interface CityCardProps {
  picture: string,
  name: string,
  title?: string,
  averageSellPrice?: string | number,
  urlObject?: URLObject,
  overriddenAlt?: string,
  onClick?: VoidFunction,
}

const CityCard: React.FC<CityCardProps> = ({
  picture,
  name,
  title,
  averageSellPrice,
  urlObject,
  overriddenAlt,
  onClick,
}) => {
  const Tag = urlObject?.as ? 'a' : 'div';

  // Prevent default behavior when both onClick and href props are provided
  const internalOnClick = React.useCallback((e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();

    if (onClick) {
      onClick();
    }
  }, [onClick]);

  return (
    <article
      css={styles.base}
      onClick={internalOnClick}
    >
      <Image
        fit
        lazyLoad
        alt={overriddenAlt ?? `Vendere casa a ${name}`}
        width="100%"
        height="100%"
        src={picture}
      />
      <div css={styles.info}>
        <h3>
          <Tag
            href={urlObject?.as}
            title={title}
          >
            <strong css={styles.name}>{name}</strong>
          </Tag>
        </h3>
        {averageSellPrice && (
          <div>€ {averageSellPrice}/mq</div>
        )}
      </div>
    </article>
  );
};

export default CityCard;
